import { registerImages, Source } from '@betty/moonlight';
import statusImages from './images/bettyStatus';
import rgImages from './images/responsibleGaming';
import landingPage from './images/landingPage';
import coinsImages from './images/coins';

const images = {...rgImages, ...statusImages, ...coinsImages}

registerImages('misc', images);
registerImages('landingPage', landingPage);

declare global {
  interface RegisteredImages {
    misc: Record<keyof typeof images, Source>;
    landingPage: Record<keyof typeof landingPage, Source>;
  }
}
